import { Link } from "react-router-dom";
import Footer from "./Footer";

export default function LegalLayout({ title, updated, children, testid }) {
  return (
    <div className="min-h-screen bg-[#FAF9F6] text-[#1A1A1A]" data-testid={testid}>
      <header className="border-b border-[#E5E0D8]">
        <div className="max-w-7xl mx-auto px-6 sm:px-12 h-16 flex items-center justify-between">
          <Link to="/" className="font-serif text-2xl tracking-tight" data-testid="legal-brand-link">
            Evervow
          </Link>
          <Link
            to="/"
            data-testid="legal-back-link"
            className="text-sm text-[#5C5C5C] hover:text-[#1A1A1A] transition-colors duration-300"
          >
            ← Back to Evervow
          </Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 sm:px-12 py-16 sm:py-24">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#7A3B3F]">Evervow</p>
        <h1 className="font-serif text-4xl sm:text-5xl font-light tracking-tighter mt-4">{title}</h1>
        {updated && <p className="mt-3 text-sm text-[#8A8A8A]">Last updated: {updated}</p>}
        <div className="mt-12 space-y-8 text-[#5C5C5C] leading-relaxed">{children}</div>
      </main>
      <Footer />
    </div>
  );
}

export const LegalSection = ({ heading, children }) => (
  <section>
    <h2 className="font-serif text-2xl text-[#1A1A1A]">{heading}</h2>
    <div className="mt-4 space-y-4">{children}</div>
  </section>
);
